import { WorkflowType } from './dispositions';

/**
 * Summary-related constants
 */

/**
 * Workflow types that support summary editing and regeneration.
 * These workflows allow users to edit section summaries and regenerate AI summaries
 * during human audit states.
 */
export const SUMMARY_EDITABLE_WORKFLOW_TYPES = [
  WorkflowType.MEDBV,
  WorkflowType.PBM,
  WorkflowType.UNIFIEDMEDBV,
  WorkflowType.BHO,
  WorkflowType.MEDBHOBV,
  WorkflowType.PA_STATUS_PBM,
  WorkflowType.PA_STATUS_MEDBV,
];
